import React from "react";
import cs from "classnames";
import style from "./AuthLayout.module.scss";

const AuthLayout = ({ children }) => (
  <div className={style.hero}>
    <img src="/assets/img/div.overflow-hidden.webp" alt="Credijusto" />
    <div className={cs("container", style.main)}>{children}</div>
  </div>
);

export default AuthLayout;
